module.exports = __webpack_public_path__ + "static/media/kasto_ramailo.7acf7a33.ogg";